// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import axios from "../../utils/BasicAuthAPI";
import { Tabs, Radio, Row, Col } from "antd";
import ZenVerBarChart from "./Common/Graph/ZenVerBarChart";
import ZenHorBarChart from "./Common/Graph/ZenHorBarChart";
import ZenGauge from "./Common/Graph/ZenGauge";





import LineGraph from "./Common/Graph/LineGraph";
import BasicBarGraphHor from "./Common/Graph/BasicBarGraphHor";
import LiraVerticalBarGraph from "./Common/Graph/LiraVerticalBarGraph";

import LiraHorizontalBarGraph from "./Common/Graph/LiraHorizontalBarGraph";
// import BasicBarGraph from "./Common/Graph/BasicBarGraph";

// import ZenHorBarChart from "./Common/Graph/ZenHorBarChart";
// import ZenVerBarChart from "./Common/Graph/ZenVerBarChart";
import ColoredBarGraph from "./Common/Graph/ColoredBarGraph";
import GaugeCorpDashboard from "./Common/Graph/GaugeCorpDashboard";
import styles from "./managerDashboard.css";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
 import digitalFactoryLogo from "../../images/DigitalFactory.png";
import { Link } from "react-router-dom";
import ManagerDashboard from "./ManagerDashboard";
import { getStyleProperties } from "../../utils/CustomFunc";
// import RadialGradient from 'react-native-radial-gradient';

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";
// const plantGridKpiHeader1 = {
//                               color: "f1c40f",
//                               paddingLeft: "10px",
//                               textAlign: "center",
//                               fontSize: "14px",
//                               fontWeight: 800,
//                             };

// const plantGridKpiValue = {
//                               color: "f1c40f",
//                               paddingLeft: "10px",
//                               textAlign: "center",
//                               fontSize: "14px",
//                               fontWeight: 800,
//                             };

class CorporateDashboard extends React.Component {
  state = {
    mainData: null,
    // dailyTrend: null,
    // hourlyTrend: null,
    // linePref: null,
    // linePerSummary: null,
    mainHorBarGraph: null,
    mainGuage:null,
    HorBarPlantOeePerf: null,




    mainHorBarGraphConfig: null,
    // mainVerBarGraph: null,
    // mainVerBarGraphData: null,
    // mainVerBarGraphConfig: null,
    // corpMainBarGraphData: null,
    // corpMainBarGraphConfig: null,
    // ZenHorBarChart1:null,
    // ZenHorBarChart2:null,
    // ZenVerBarChart1:null,

    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {
    
    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    this.fetchTrendData(e.target.value);
  };

  changeLid = (lid) => {
    let val =
      this.state.lid === "all" ? lid : this.state.lid === lid ? "all" : lid;
    this.setState({ ...this.state, lid: val, dataLoading: true });
    this.fetchTrendData(this.state.selectedTab, val, this.state.selectedMnt);
  };

  getTabs() {
    liracrypt
      .get("/corp/corpdashdynamicparam", {})
      .then((response) => {
        let __tabs = response.data.data;
        this.setState(
          {
            tabsData: __tabs,
            selectedTab: __tabs?.find((x) => x.isDefault === true)?.subTyp,
          },
          () => {
            if (this._isMounted && this.state.selectedTab) {
              this.fetchTrendData(this.state.selectedTab);
            }
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    
    // this.clearCache();
    // this.updateMdictVersion();
    this.props.setPageHeader("Dashboard");
    this._isMounted = true;
    this.getTabs();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab, lid = "all", mnt = "all") => {
    liracrypt
      .get("/textapi", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        dn: "CorpDashboardTrendPlants",
      })
      .then(({ data }) => {
        const newData = { ...data };
        let newDataConfig = {};

        newDataConfig["legend"] = newData["data"]["legend"];
        newDataConfig["title"] = newData["data"]["title"];
        newDataConfig["mainHorBarGraphConfig"] =
          newData["data"]["mainHorBarGraph"]["config"];
        newDataConfig["mainHorBarGraphData"] = newData["data"][
          "mainHorBarGraph"
        ]["data"].map((x) => {
          return { _id: x._id, val: x.val, name: x.name, color: "#fd9644" };
        });

      //   newDataConfig["sub1HorBarGraphConfig"] =
      //     newData["data"]["sub1HorBarGraph"]["config"];
      //   newDataConfig["sub1HorBarGraphData"] = newData["data"][
      //     "sub1HorBarGraph"
      //   ]["data"].map((x) => {
      //     return { _id: x._id, val: x.val, name: x.name, color: "#fd9644" };
      //   });

      //   newDataConfig["sub2HorBarGraphConfig"] =
      //   newData["data"]["sub2HorBarGraph"]["config"];
      // newDataConfig["sub2HorBarGraphData"] = newData["data"][
      //   "sub2HorBarGraph"
      // ]["data"].map((x) => {
      //   return { _id: x._id, val: x.val, name: x.name, color: "#fd9644" };
      // });

        // newDataConfig["mainVerBarGraphConfig"] =
        //   newData["data"]["mainVerBarGraph"]["config"];
        // newDataConfig["mainVerBarGraphData"] = newData["data"][
        //   "mainVerBarGraph"
        // ]["data"].map((x) => {
        //   return {
        //     _id: x._id,
        //     myColumn: x.val,
        //     lineSeries1Data: x.tgt,
        //     lineSeries2Data: x.mtd,
        //   };
        // });

        // newDataConfig["corpMainBarGraphConfig"] =
        //   newData["data"]["corpMainBarGraph"]["config"];
        // newDataConfig["corpMainBarGraphData"] = newData["data"][
        //   "corpMainBarGraph"
        // ]["data"].map((x) => {
        //   return {
        //     _id: x._id,
        //     myColumn: x.val,
        //     lineSeries1Data: x.tgt,
        //     lineSeries2Data: x.mtd,
        //   };
        // });


        // newDataConfig["ZenHorBarChart1"] = newData["data"]["ZenHorBarChart1"];
        // newDataConfig["ZenHorBarChart2"] = newData["data"]["ZenHorBarChart2"];
        // newDataConfig["ZenVerBarChart1"] = newData["data"]["ZenVerBarChart1"];






        newDataConfig["mainData"] = { ...newData };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...newDataConfig,
              loading: false,
              dataLoading: false,
            },
            () => {
              
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  changeBasicGraph(data) {
    let val =
      this.state.selectedMnt === "all"
        ? data._id
        : this.state.selectedMnt === data._id
        ? "all"
        : data._id;
    this.setState({
      selectedMnt: val,
      dataLoading: true,
    });
    this.fetchTrendData(this.state.selectedTab, this.state.lid, val);
  }

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#1e1e2f",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <div
                className="logo"
                style={{
                  margingLeft: 14,
                  padding: 10,
                }}
              >
                <img src={digitalFactoryLogo} alt="sarex" width="80" />
              </div>
              <Radio.Group
                className="managerTabs"
                value={"small"}
                onChange={this.onChange}
              >
                {this.state.tabsData &&
                  this.state.tabsData.map((tab, index) => (
                    <Radio.Button
                      key={index}
                      className={tab?.label?.toLowerCase()}
                      style={{
                        background: "#26293b",
                        border: "2px solid #3c3e4f",
                        color: tab?.color,
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: 600,
                        boxShadow: boxShadow,
                        maxWidth: "200px",
                      }}
                      value={tab?.subTyp}
                    >
                      {tab?.label}
                    </Radio.Button>
                  ))}
              </Radio.Group>
              <div
                style={{
                  //   boxShadow:
                  //     "rgb(30 30 30) 5px 5px 10px, rgb(46 46 46) -5px -5px 10px",
                  borderRadius: 10,
                  padding: 10,
                  marginRight: 25,
                  marginBottom: 13,

                  background: "#26293b",
                  //   backgroundImage:
                  //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,0.8748541652989321) 57%, rgba(33,32,40,1) 100%)",
                  border: "2px solid #3c3e4f",
                }}
              >
                <Link to="/dashboard">
                  <HomeOutlined
                    style={{
                      fontSize: 25,
                    }}
                  />
                </Link>
              </div>
            </div>
            {this.state.loading === false ? (
              <div>
                <Row>
                  <Col span={4}>
                    {this.state.mainData && this.state.mainData.data.icon ? (
                      <div
                        style={{
                          margin: "10px",
                          padding: "10px",
                          //   boxShadow:
                          //     "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                          borderRadius: "10px",
                          background: "#26293b",
                          //   backgroundImage:
                          //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,1) 57%, rgba(33,32,40,1) 100%)",
                          border: "2px solid #3c3e4f",
                        }}
                      >
                        {/* <br></br> */}

                        <div
                          style={{
                            color: "#b1b0b5",
                            paddingTop: "0px",
                            paddingLeft: "0px",
                            textAlign: "center",
                            fontSize: "20px",
                            fontWeight: 600,
                          }}
                        >
                          {`${this.state.mainData.data.plantName} `}
                        </div>
                        <div style={{ height: "100px" }}>
                          {this.state.mainData &&
                          this.state.mainData.data.corpRadarChart.valPerc ? (
                            <GaugeCorpDashboard
                              divId={"MainValPerc"}
                              valPerc={
                                this.state.mainData.data.corpRadarChart.valPerc
                              }
                              barColor={
                                this.state.mainData.data.corpRadarChart.barColor
                              }
                              labelText={
                                this.state.mainData.data.corpRadarChart.valTxt
                              }
                              labelColor={
                                this.state.mainData.data.corpRadarChart
                                  .labelColor
                              }
                              labelFontSize={10}
                              chartDivWidth={"95%"}
                              chartDivHeight={"100px"}
                              chartDivBorderRadius={"10px"}
                            />
                          ) : null}
                        </div>

                        <div
                          style={{
                            color: "#b1b0b5",
                            paddingTop: "0px",
                            paddingLeft: "0px",
                            textAlign: "center",
                            fontSize: "11px",
                            fontWeight: 400,
                          }}
                        >
                          {`${this.state.mainData.data.corpRadarChart.footer} `}
                        </div>

                        {/* <div>
                          <LiraVerticalBarGraph
                            divId={"corpMainBarGraph"}
                            chartDiv={{
                              width: "95%",
                              height: "120px",
                              padding: (0, 0, 0, 0),
                              borderRadius: "0px",
                              background: null,

                              grid: {
                                gridHorizontal: false,
                                gridVertical: false,
                                gridColor: "#95a5a6",
                              },
                            }}
                            categoryAxis={{
                              color: "#bdc3c7",
                              fontSize: 10,
                              orientation: "ang", // hor  ver  ang
                              wrap: false,
                              wrapMaxWidth: 30,
                            }}
                            columnSeries={{
                              name: "MyColumnName",
                              cornerRadius: [0, 0, 0, 0],
                              color:"#f1c40f",
                              shadow: false,
                              columnSeriesvalueY: "myColumn",
                              columnWidth: 80,
                            }}
                            lineSeries1={{
                              enable: false,
                              name: "MySeries1Name",
                              smoothenCurve: false,
                              lineColor: "#e67e22",
                              lineStrokeWidth: 2,
                              shadow: true,
                              lineSeriesvalueY: "lineSeries1Data",
                            }}
                            lineSeries2={{
                              enable: false,
                              name: "MySeries2Name",
                              smoothenCurve: false,
                              lineColor: "#2ecc71",
                              lineStrokeWidth: 2,
                              shadow: true,
                              lineSeriesvalueY: "lineSeries2Data",
                            }}
                            title={{
                              enable: false,
                              color: "#b1b0b5",
                              fontSize: 20,
                              val: this.state.mainVerBarGraphConfig.title,
                            }}
                            valueAxis={{
                              enable: false,
                              color: "#bdc3c7",
                              fontSize: 10,
                            }}
                            valueLabel={{
                              enable: false,
                              color: "#bdc3c7",
                              fontSize: 10,
                              val: "[bold]{valueY}[/]%",
                              verticalCenter: "center",
                              horizontalCenter: "center",
                              dx: 5, // displacement x axis
                              dy: 15, // displacement y axis
                            }}
                            legend={{
                              enable: false,
                              position: "top",
                              color: "#bdc3c7",
                            }}
                            _id={"_id"}
                            data={this.state.corpMainBarGraphData}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div> */}
                      </div>
                    ) : null}
                  </Col>
                  <Col span={8} style={{}}>
                    <div
                      style={{
                        margin: "10px",
                        padding: "10px",
                        //   boxShadow:
                        //     "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                        borderRadius: "10px",
                        background: "#26293b",
                        //   backgroundImage:
                        //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,1) 57%, rgba(33,32,40,1) 100%)",
                        border: "2px solid #3c3e4f",
                      }}
                    >
                      {this.state.mainHorBarGraphData ? (
                        <BasicBarGraphHor
                          divId={"mainHorBarGraph"}
                          barColor={this.state.mainHorBarGraphConfig.barColor}
                          barCornerRadius={[0, 0, 0, 0]}
                          labelColor={"#e67e22"}
                          labelFontSize={11}
                          chartDivWidth={"95%"}
                          chartDivHeight={"253px"}
                          chartDivBorderRadius={"10px"}
                          title={this.state.mainHorBarGraphConfig.title}
                          titleFontSize={20}
                          titleColor={"#b1b0b5"}
                          colValue={"val"}
                          category={"_id"}
                          lineSeries={"tgt"}
                          data={this.state.mainHorBarGraphData}
                          onChange={(data) => this.changeBasicGraph(data)}
                        />
                      ) : null}
                    </div>
                  </Col>

                  <Col span={12}>
                    {this.state.mainData && this.state.mainData.data.icon ? (
                      <div
                        style={{
                          margin: "10px",
                          padding: "10px",
                          //   boxShadow:
                          //     "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                          borderRadius: "10px",
                          background: "#26293b",
                          //   backgroundImage:
                          //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,1) 57%, rgba(33,32,40,1) 100%)",
                          border: "2px solid #3c3e4f",
                        }}
                      >
                        <Row>
                          <Col span={8}>
                            <div
                              style={{
                                display: "inline-block",
                                paddingLeft: "10px",
                                paddingTop: "10px",
                                paddingBottom: "2px",
                                width: "90%",

                                margin: "0px",

                                background: "#26293b",
                                border: "2px solid #3c3e4f",
                                borderRadius: "10px",
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <img
                                  src={
                                    this.state.mainData.data.plantBlocks.r1c1
                                      .icon
                                  }
                                  alt={
                                    this.state.mainData.data.plantBlocks.r1c1
                                      .icon
                                  }
                                  height="50px"
                                  width="50px"
                                />
                              </span>
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <div
                                  style={{
                                    color:
                                      this.state.mainData.data.plantBlocks.r1c1
                                        .col1,
                                    paddingTop: "0px",
                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "20px",
                                    fontWeight: 400,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r1c1.txt1} `}
                                </div>

                                <div
                                  style={{
                                    color: "#b1b0b5",

                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r1c1.txt2} `}
                                </div>
                              </span>

                              {/* DIV FOR  KPI VAL STARTS HERE */}

                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c1.txt3A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c1.col3,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c1.txt3B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c1.txt4A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c1.col4,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c1.txt4B} `}
                                  </span>
                                </span>
                              </div>
                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c1.txt5A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c1.col5,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c1.txt5B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c1.txt6A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c1.col6,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c1.txt6B} `}
                                  </span>
                                </span>
                              </div>
                            </div>

                            <div style={{ paddingTop: "10px" }}></div>
                          </Col>

                          <Col span={8}>
                            <div
                              style={{
                                display: "inline-block",
                                paddingLeft: "10px",
                                paddingTop: "10px",
                                paddingBottom: "2px",
                                width: "90%",

                                margin: "0px",

                                background: "#26293b",
                                border: "2px solid #3c3e4f",
                                borderRadius: "10px",
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <img
                                  src={
                                    this.state.mainData.data.plantBlocks.r1c2
                                      .icon
                                  }
                                  alt={
                                    this.state.mainData.data.plantBlocks.r1c2
                                      .icon
                                  }
                                  height="50px"
                                  width="50px"
                                />
                              </span>
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <div
                                  style={{
                                    color:
                                      this.state.mainData.data.plantBlocks.r1c2
                                        .col1,
                                    paddingTop: "0px",
                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "20px",
                                    fontWeight: 400,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r1c2.txt1} `}
                                </div>
                                <div
                                  style={{
                                    color: "#b1b0b5",

                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r1c2.txt2} `}
                                </div>
                              </span>

                              {/* DIV FOR  KPI VAL STARTS HERE */}

                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c2.txt3A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c2.col3,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c2.txt3B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c2.txt4A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c2.col4,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c2.txt4B} `}
                                  </span>
                                </span>
                              </div>
                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c2.txt5A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c2.col5,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c2.txt5B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c2.txt6A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c2.col6,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c2.txt6B} `}
                                  </span>
                                </span>
                              </div>
                            </div>

                            <div style={{ paddingTop: "10px" }}></div>
                          </Col>

                          <Col span={8}>
                            <div
                              style={{
                                display: "inline-block",
                                paddingLeft: "10px",
                                paddingTop: "10px",
                                paddingBottom: "2px",
                                width: "90%",

                                margin: "0px",

                                background: "#26293b",
                                border: "2px solid #3c3e4f",
                                borderRadius: "10px",
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <img
                                  src={
                                    this.state.mainData.data.plantBlocks.r1c3
                                      .icon
                                  }
                                  alt={
                                    this.state.mainData.data.plantBlocks.r1c3
                                      .icon
                                  }
                                  height="50px"
                                  width="50px"
                                />
                              </span>
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <div
                                  style={{
                                    color:
                                      this.state.mainData.data.plantBlocks.r1c3
                                        .col1,
                                    paddingTop: "0px",
                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "20px",
                                    fontWeight: 400,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r1c3.txt1} `}
                                </div>
                                <div
                                  style={{
                                    color: "#b1b0b5",

                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r1c3.txt2} `}
                                </div>
                              </span>

                              {/* DIV FOR  KPI VAL STARTS HERE */}

                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c3.txt3A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c3.col3,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c3.txt3B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c3.txt4A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c3.col4,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c3.txt4B} `}
                                  </span>
                                </span>
                              </div>
                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c3.txt5A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c3.col5,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c3.txt5B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c3.txt6A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r1c3.col6,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r1c3.txt6B} `}
                                  </span>
                                </span>
                              </div>
                            </div>

                            <div style={{ paddingTop: "10px" }}></div>
                          </Col>
                        </Row>

                        <Row>
                          <Col span={8}>
                            <div
                              style={{
                                display: "inline-block",
                                paddingLeft: "10px",
                                paddingTop: "10px",
                                paddingBottom: "2px",
                                width: "90%",

                                margin: "0px",

                                background: "#26293b",
                                border: "2px solid #3c3e4f",
                                borderRadius: "10px",
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <img
                                  src={
                                    this.state.mainData.data.plantBlocks.r2c1
                                      .icon
                                  }
                                  alt={
                                    this.state.mainData.data.plantBlocks.r2c1
                                      .icon
                                  }
                                  height="50px"
                                  width="50px"
                                />
                              </span>
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <div
                                  style={{
                                    color:
                                      this.state.mainData.data.plantBlocks.r2c1
                                        .col1,
                                    paddingTop: "0px",
                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "20px",
                                    fontWeight: 400,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r2c1.txt1} `}
                                </div>
                                <div
                                  style={{
                                    color: "#b1b0b5",

                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r2c1.txt2} `}
                                </div>
                              </span>

                              {/* DIV FOR  KPI VAL STARTS HERE */}

                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c1.txt3A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c1.col3,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c1.txt3B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c1.txt4A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c1.col4,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c1.txt4B} `}
                                  </span>
                                </span>
                              </div>
                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c1.txt5A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c1.col5,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c1.txt5B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c1.txt6A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c1.col6,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c1.txt6B} `}
                                  </span>
                                </span>
                              </div>
                            </div>

                            <div style={{ paddingTop: "10px" }}></div>
                          </Col>

                          <Col span={8}>
                            <div
                              style={{
                                display: "inline-block",
                                paddingLeft: "10px",
                                paddingTop: "10px",
                                paddingBottom: "2px",
                                width: "90%",

                                margin: "0px",

                                background: "#26293b",
                                border: "2px solid #3c3e4f",
                                borderRadius: "10px",
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <img
                                  src={
                                    this.state.mainData.data.plantBlocks.r2c2
                                      .icon
                                  }
                                  alt={
                                    this.state.mainData.data.plantBlocks.r2c2
                                      .icon
                                  }
                                  height="50px"
                                  width="50px"
                                />
                              </span>
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <div
                                  style={{
                                    color:
                                      this.state.mainData.data.plantBlocks.r2c2
                                        .col1,
                                    paddingTop: "0px",
                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "20px",
                                    fontWeight: 400,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r2c2.txt1} `}
                                </div>
                                <div
                                  style={{
                                    color: "#b1b0b5",

                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r2c2.txt2} `}
                                </div>
                              </span>

                              {/* DIV FOR  KPI VAL STARTS HERE */}

                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c2.txt3A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c2.col3,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c2.txt3B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c2.txt4A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c2.col4,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c2.txt4B} `}
                                  </span>
                                </span>
                              </div>
                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c2.txt5A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c2.col5,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c2.txt5B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c2.txt6A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c2.col6,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c2.txt6B} `}
                                  </span>
                                </span>
                              </div>
                            </div>

                            <div style={{ paddingTop: "10px" }}></div>
                          </Col>

                          <Col span={8}>
                            <div
                              style={{
                                display: "inline-block",
                                paddingLeft: "10px",
                                paddingTop: "10px",
                                paddingBottom: "2px",
                                width: "90%",

                                margin: "0px",

                                background: "#26293b",
                                border: "2px solid #3c3e4f",
                                borderRadius: "10px",
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <img
                                  src={
                                    this.state.mainData.data.plantBlocks.r2c3
                                      .icon
                                  }
                                  alt={
                                    this.state.mainData.data.plantBlocks.r2c3
                                      .icon
                                  }
                                  height="50px"
                                  width="50px"
                                />
                              </span>
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "60px",
                                  verticalAlign: "top",
                                }}
                              >
                                <div
                                  style={{
                                    color:
                                      this.state.mainData.data.plantBlocks.r2c3
                                        .col1,
                                    paddingTop: "0px",
                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "20px",
                                    fontWeight: 400,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r2c3.txt1} `}
                                </div>
                                <div
                                  style={{
                                    color: "#b1b0b5",

                                    paddingLeft: "0px",
                                    textAlign: "center",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {`${this.state.mainData.data.plantBlocks.r2c3.txt2} `}
                                </div>
                              </span>

                              {/* DIV FOR  KPI VAL STARTS HERE */}

                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c3.txt3A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c3.col3,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c3.txt3B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c3.txt4A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c3.col4,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c3.txt4B} `}
                                  </span>
                                </span>
                              </div>
                              <div style={{ paddingTop: "5px", marginLeft: 0 }}>
                                <span>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c3.txt5A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c3.col5,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c3.txt5B} `}
                                  </span>
                                </span>
                                <span style={{ paddingLeft: "10px" }}>
                                  <span
                                    style={{
                                      color: "#b1b0b5",
                                      paddingTop: "30px",
                                      paddingLeft: "0px",
                                      textAlign: "left",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c3.txt6A} `}
                                  </span>

                                  <span
                                    style={{
                                      paddingLeft: "0px",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color:
                                        this.state.mainData.data.plantBlocks
                                          .r2c3.col6,
                                    }}
                                  >
                                    {`${this.state.mainData.data.plantBlocks.r2c3.txt6B} `}
                                  </span>
                                </span>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    ) : null}

 
                  </Col>
                </Row>

                {/* //SECOND ROW */}

                <Row>
                  <Col span={6}>
                  {/* <div
                      style={{
                        margintop: "0px",
                        paddingTop: "0px",
                        borderRadius: "10px",
                        background: "#26293b",
                        border: "2px solid #3c3e4f",
                      }}
                    >
                        <ZenHorBarChart
                            divId={"ZenHorBarChart1"}
                            data={this.state.ZenHorBarChart1.data}
                            config={this.state.ZenHorBarChart1.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                    </div> */}
                  </Col>
                  <Col span={6} style={{}}>
                  {/* <div
                      style={{
                        margin: "0px",
                        padding: "0px",
                        borderRadius: "10px",
                        background: "#26293b",
                        border: "2px solid #3c3e4f",
                      }}
                    >
                                <ZenHorBarChart
                            divId={"ZenHorBarChart2"}
                            data={this.state.ZenHorBarChart2.data}
                            config={this.state.ZenHorBarChart2.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          /> 
                    </div> */}
                  </Col>

                  <Col span={12}>
               

                    {/* <div
                      style={{
                        margin: "10px",
                        padding: "10px",
                        //   boxShadow:
                        //     "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                        borderRadius: "10px",
                        background: "#26293b",
                        //   backgroundImage:
                        //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,1) 57%, rgba(33,32,40,1) 100%)",
                        border: "2px solid #3c3e4f",
                      }}
                    >
                       <ZenVerBarChart
                            divId={"ZenVerBarChart1"}
                            // respData = {this.state.ZenVerBarChart}
                            data={this.state.ZenVerBarChart1.data}
                            config={this.state.ZenVerBarChart1.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                    </div> */}

               
                  </Col>
                </Row>
                <Row className="outer_table">
                  {/* <Col span={12}>
                    {this.state.linePref ? (
                      <ColoredBarGraph
                        divId={"linePref"}
                        title={this.state.title.linePerf}
                        barColor={this.state.mainData.data.color}
                        colValue={"val"}
                        category={"_id"}
                        data={this.state.linePref}
                        changeLid={this.changeLid}
                      />
                    ) : null}
                  </Col> */}
                </Row>




                <Row className="outer_table">
                
               <div style={{ height: "2000px" ,width: "100%" }}>

               </div>
                </Row>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default CorporateDashboard;
